import packageJson from '../package.json';

export function logVersion(): void {
  const appName = packageJson.name;

  console.log(
    `%c ${appName} v${packageJson.version} `,
    'color: #fff; background: #1a5276; padding: 2px 8px; border-radius: 4px; font-weight: bold;'
  );
}
